import { useTranslation } from 'react-i18next';

import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';

import { MAP_TYPES } from '../features/digitalStore/constants/mapTypes';

export default function MapTypeToggle({ mapType, setMapType, hasEnhancedMap }) {
  const { t } = useTranslation();

  if (!hasEnhancedMap) return null;

  return (
    <ToggleButtonGroup
      value={mapType}
      exclusive
      onChange={(e, newMapType) => {
        if (newMapType !== null) {
          setMapType(newMapType);
        }
      }}
      aria-label="map type"
      size="small"
      sx={{ backgroundColor: 'background.paper' }}
    >
      <ToggleButton value={MAP_TYPES.LEGACY} aria-label="legacy map">
        {t('cws_app.digital_store.legacy_map', 'Legacy Map')}
      </ToggleButton>
      <ToggleButton value={MAP_TYPES.ENHANCED} aria-label="new map">
        <IconComponent iconName="sparkles" style={{ marginRight: '4px', fontSize: '16px' }} />
        {t('cws_app.digital_store.new_map', 'New Map')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}